














import { Component, Inject, Vue, Prop } from "vue-property-decorator";
import { TranslateResult } from "vue-i18n";

@Component
export default class FormConfirmBeforeDelete extends Vue {
    @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;
    @Prop({ type: Boolean, required: true, default: false }) show!: boolean;

    onClose() {
        this.$emit("close", false);
    }

    onCancel() {
        this.$emit("cancel", false);
    }

    onOk() {
        this.$emit("ok");
    }
}
